import React, { useContext, useEffect, useState } from 'react'
import styles from '../styles/settings.module.css'
import StateContext from '../context/state/StateContext'
import UserContext from '../context/user/UserContext';
import { toast } from 'react-toastify';
import Loading from '../components/Loading';
import axios from 'axios';


const Profile = () => {

    const { setModal, setLoading } = useContext(StateContext);
    const { user, setUser, token } = useContext(UserContext)
    const [data, setData] = useState({ username: "", name: "", email: "", phone: "", password: "", picture: "" });
    const [previewSrc, setPreviewSrc] = useState(null);
    const [error, setError] = useState('');
    const [deletePicture, setDeletePicture] = useState(false);


    useEffect(() => {
        if (user) {
            setData({ username: user.username, name: user.name, email: user.email, phone: user.phone, picture: user.picture });
            setPreviewSrc(process.env.REACT_APP_API_URL + `uploads/${user.picture}`);
        }
    }, [user]);

    const handleChange = (e) => {
        setError('')
        setData({ ...data, [e.target.name]: e.target.value })
    }

    const handleFileChange = (e) => {
        setError('')
        console.log("hello");
        setDeletePicture(false)
        const file = e.target.files[0];
        if (file) {
            setData((prevData) => ({
                ...prevData,
                picture: file,
            }));

            // Generate a URL for the image preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewSrc(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    console.log(previewSrc);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading({ open: true, text: 'Saving...' })
            const formData = new FormData();
            formData.append('username', data.username)
            formData.append('name', data.name);
            formData.append('email', data.email);
            formData.append('phone', data.phone);
            formData.append('deletePicture', deletePicture)
            formData.append('password', data.password);
            formData.append('picture', data.picture); // Ensure pictureFile is a File object or Blob
            console.log(formData);

            const response = await axios.post(process.env.REACT_APP_API_URL + 'api/auth/profile', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'auth-token': token,
                }
            });
            const json = response;
            console.log(json);
            if (json.data.success) {
                setUser(json.data.data)
                toast.success(json.data.message)
                setData((prevData) => ({
                    ...prevData,
                    password: "",
                }));
            } else {
                console.log(json.data.error);
                setError(json.data.error)
                // toast.error(json.response.data.error)
            }


        } catch (error) {
            console.log(error);
            setError(error.response.data.error[0].msg || error.response.data.error)
            toast.error(error)
        } finally {
            setLoading({ open: false, text: '' })
        }
    }

    const handleDeletePicture = () => {
        setPreviewSrc(null)
        setDeletePicture(true);
        setData((prevData) => {
            return { ...prevData, picture: null }
        })
    }

    return (
        <>
            <Loading />
            <form action="" className={styles.form_container} onSubmit={handleSubmit}>
                <h5>Profile Picture</h5>
                <div className="d-flex align-items-sm-center align-items-start flex-sm-row flex-column" style={{ gap: "10px" }}>
                    {data.picture !== 'require(`../../../backend/uploads/user-images/null`)' && data.picture !== null ? <img src={previewSrc} className='img-fluid' alt="" /> : <i className={`bx bxs-user-circle ${styles.img}`}></i>}
                    <div className="d-flex" style={{ gap: "10px" }}>
                        <label htmlFor="uploadImg" className={`button2 ${styles.button}`}>
                            Change Picture
                            <input type="file" accept='image' onChange={handleFileChange} name="uploadImg" id="uploadImg" />
                        </label>
                        <button type='button' onClick={handleDeletePicture} className={`button2 delete ${styles.button}`} style={{ width: "fit-content", borderRadius: "6px" }}> <i className=' fa-solid fa-trash'></i> </button>
                    </div>
                </div>

                {user.role === "admin" ? <><div className="row g-2">
                    <div className="col-md-6 col-12">
                        <label htmlFor="name" className='mt-3'>Profile Name</label>
                        <div className="inputField">
                            <input type="text" value={data.name} name='name' id='name' onChange={handleChange} placeholder='Enter your Name' />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <label htmlFor="username" className='mt-3'>User Name</label>
                        <div className="inputField">
                            <input type="text" value={data.username} name='username' id='username' onChange={handleChange} placeholder='Enter your Username' />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <label htmlFor="phone" className='mt-3'>Phone Number</label>
                        <div className="inputField">
                            <input type="text" value={data.phone} maxLength={10} name='phone' id='phone' onChange={handleChange} placeholder='Enter your Phone Number' />
                        </div>  
                    </div>
                </div>

                    <div className="row g-2">
                        <div className="col-sm-8">
                            <label htmlFor="email">Email</label>
                            <div className="inputField">
                                <input type="email" value={data.email} name='email' id='email' onChange={handleChange} placeholder='Enter your Email' />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <label htmlFor="password">Password</label>
                            <div className="inputField">
                                <input type="password" name='password' value={data.password} id='password' onChange={handleChange} placeholder='Enter password' />
                            </div>
                            {false ? <p style={{ color: "green", marginTop: "-12px" }}>Correct</p> : null}
                        </div>
                    </div>
                </> :
                    <><div className="row g-2"><div className="col-md-6 col-12">
                        <label htmlFor="name" className='mt-3'>Profile Name</label>
                        <div className="inputField">
                            <input type="text" value={data.name} name='name' id='name' onChange={handleChange} placeholder='Enter your Name' />
                        </div>
                    </div></div>
                    </>}
                {error ? <p style={{ color: "red" }}>{error}</p> : null}
                <div className="d-flex justify-content-end align-items-center mt-4">
                    <button type='submit' className={`button2 ${styles.button}`} disabled={false}>Save Changes</button>
                </div>
            </form>
        </>
    )
}

export default Profile
